import { Card, CardContent } from '@cortex/ui';
import { Construction } from 'lucide-react';
import { useParams } from 'react-router';

/** Stands in for a page until its epic ports it. */
export function PlaceholderPage({ title, epic, path }: { title: string; epic: string; path: string }) {
  const { slug: _slug, branch: _branch, ...params } = useParams();
  const entries = Object.entries(params).filter(([k]) => k !== '*');
  return (
    <div className="p-6 lg:p-8 bg-page-bg min-h-full" data-testid="placeholder-page" data-page={path}>
      <h1 className="text-[28px] font-medium leading-tight text-page-title mb-6">{title}</h1>
      <Card className="bg-card-bg border-card-border max-w-2xl">
        <CardContent className="flex items-start gap-4">
          <Construction size={28} className="shrink-0 text-page-muted" />
          <div className="flex flex-col gap-2 text-sm text-page-text">
            <p>
              This page is a placeholder in the new shell. It is built in <strong>{epic}</strong> of the
              roadmap.
            </p>
            <p className="text-page-muted font-mono">{path}</p>
            {entries.length > 0 && (
              <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-page-muted">
                {entries.map(([k, v]) => (
                  <div key={k} className="contents">
                    <dt className="font-medium">{k}</dt>
                    <dd className="font-mono">{v}</dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
